var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSpot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.177,
    height: 8.236,
    viewBox: "0 0 6.177 8.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    id: "Icon_awesome-map-marker-alt",
    "data-name": "Icon awesome-map-marker-alt",
    d: "M2.771,8.069C.434,4.681,0,4.334,0,3.088a3.088,3.088,0,0,1,6.177,0c0,1.245-.434,1.593-2.771,4.981a.386.386,0,0,1-.635,0Zm.317-3.694A1.287,1.287,0,1,0,1.8,3.088,1.287,1.287,0,0,0,3.088,4.375Z",
    fill: "rgba(0,0,0,0.64)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpot);
export default __webpack_public_path__ + "static/media/icon-spot.80d244f6b93505c3561986aa6d9d6877.svg";
export { ForwardRef as ReactComponent };